import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { API_URL } from '.././constants/apiurl-constants';
import { SessionService } from '.././session-service/session.service';
import { File_TYPE } from '../constants/app-constants';

@Injectable({ providedIn: 'root' })
export class UploadedFileListService {

  constructor(private _sessionService: SessionService) { }

  getEmployeeFiles(engagementId: number, fileType: number, isNewUpload: boolean) {
    if (fileType == File_TYPE.BUSINESS_COMPONENT)
      return this._sessionService.apiUrlGet(API_URL.GETUPLOADDATAFILE + '?engagementId=' + engagementId + '&fileType=' + 2 + "," + 15 + '&isNewUpload=' + isNewUpload);
    else
      return this._sessionService.apiUrlGet(API_URL.GETUPLOADDATAFILE + '?engagementId=' + engagementId + '&fileType=' + fileType + '&isNewUpload=' + isNewUpload);
  }
  public downloadUploadedFile(engagementId: number, fileId, fileType: number): Observable<Blob> {
    let downloadFileUrl = API_URL.DOWNLOADDATAFILE + '?fileId=' + fileId + '&engagementId=' + engagementId + '&fileType=' + fileType;
    return this._sessionService.downloadAsFileGet(downloadFileUrl);
  }
}
